import { GettingStartedBody } from "./GettingStartedBody";
import { GettingStartedHero } from "./GettingStartedHero";
import { GettingStartedHeroImage } from "./GettingStartedHeroImage";
import { MarketingPageLayout } from "../../components/MarketingPageLayout";
import { BottomCTA } from "../../sections/BottomCTA";

export function GettingStartedPage() {
  return (
    <MarketingPageLayout current="blog">
      <GettingStartedHero />
      <GettingStartedHeroImage />
      <GettingStartedBody />
      <BottomCTA />
    </MarketingPageLayout>
  );
}
